import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './QuotesSlider.scss';
import imgslide from '../../images/quote.jpg'
const quotes = [
    { 
        text: "Proper alignment isn't just about straightening your body—it's about giving your body the freedom to function at its best.", 
    },
    { 
        text: "Strength is not just about lifting heavy weights—it's about lifting yourself up to live a life without limits.", 
    },
    { 
        text: "Thrive beyond recovery—unlock the energy, vitality, and movement to live life on your terms.",  
    },
];

const QuotesSlider = () => {
    const backgroundImage = imgslide;
    const navigate = useNavigate();

    return (
        <div className='quotes'>
            <div 
                className="quotes-slider" 
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: '85vh',
                    position: 'relative',
                    color: 'white',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    filter: 'contrast(105%) brightness(40%)',
                    zIndex: '0'
                }}
            ></div>
            <div className='quote-content-div' style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: '1', zIndex: '1' }}>
                <div className='quote-content'>
                    <h2>Book An Appointment with Our Experienced <br/> Physiotherapist</h2>
                    <p style={{ marginTop: '0' }}>Proper alignment isn't just about straightening your body—it's about giving your<br/>
                        body the freedom to function at its best.</p>
                    <button 
                        className="button primary" 
                        style={{ marginTop: '15px' }}
                        onClick={() => window.location.href = 'https://mantraflexinc.janeapp.com/'}>
                            Book Appointment
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QuotesSlider;
